import api from '@edu-fe/api'

export default {
  name: 'diversion',
  getMediaData: api.create('/course/chapter_detail'),
  getSchedule: (courseId, position=0) => {
    return api.create(`/course/schedule?courseId=${courseId}&position=${position}`)
  },
  collect: (courseId,chapterId,status) => {
    return api.create(`/course/chapter/collect?courseId=${courseId}&chapterId=${chapterId}&status=${status}`,{method: 'post'})
  },
  add: api.create('/course/add?type=4',{method: 'post'}),
}
